
import React from 'react'

export default ({onClick}) => {
  return (
    <div>
            
    <h2 className="text-center">Welcome to Rehabmart's</h2>
    <h1 className="text-center">Virtual Dizzy Lab!</h1>
    <div className="check">
        
    <h5>Our goal is to:</h5>
        <ul>
            <li>
                <div className="box clk">
                    <i className="fas fa-check show-hide"></i>
                </div>Narrow down some reasons why someone might feel dizzy
            </li>
            <li>
                <div className="box clk2">
                    <i className="fas fa-check show-hide2"></i>
                </div>Provide resources for you to learn more about dizziness
            </li>
            <li>
                <div className="box clk3">
                    <i className="fas fa-check show-hide3"></i>
                </div>Guide you to treatment options, if you need them
            </li>
            
        </ul>
        <button className="btn btn-danger" onClick={onClick.bind(this,2,false)}>Let’s Get Started</button>
    </div>
   
  </div>

  )
}

